import { Pill } from './pill';
import { Pillbox } from './pillbox';

export { Pillbox, Pill };
